import { atom } from 'recoil';

export const signatureStateAtom = atom({
  key: 'signatureState',
  default: false,
});
